import React, { useMemo } from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from 'app/cluster-styles/useStyles';
import useProviderData from '../hooks/useProviderData';

export default function RegionSelector({ provider, value, onChange, allowedRegionIds, className }) {
    const classes = useStyles();
    const { regions } = useProviderData(provider);

    const visibleRegions = useMemo(() => {
        if (!allowedRegionIds || allowedRegionIds.length === 0) return regions;
        return regions.filter((r) => allowedRegionIds.includes(r.region_id));
    }, [regions, allowedRegionIds]);

    const safeValue = regions.some((r) => r.region_id === value) ? value : '';

    return (
        <TextField
            select
            className={clsx(classes.input, className || "flex-1")}
            id="rm-region"
            name="rm_region_id"
            label="Region"
            variant="outlined"
            value={safeValue}
            onChange={(e) => onChange(e.target.value)}
            required
            SelectProps={{
                MenuProps: {
                    PaperProps: {
                        style: { maxHeight: 300 },
                    },
                },
            }}
        >
            {visibleRegions.map((region) => (
                <MenuItem key={region.region_id} value={region.region_id}>
                    {region.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
